export const DEVICE_TOKEN_IDENTIFIER = 'push.token';